module.exports = __webpack_public_path__ + "static/img/home_cn_solution1.aa95542.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgs/home_cn_solution1.png
// module id = +APG
// module chunks = 0